import { catalog } from '@nolens/i18n';

export const importText = catalog(
  {
    import: 'Import',
    title: 'Import a guide',
    hint: 'Ask an AI for the steps of a task and import its answer. The steps have no screenshots yet: the first time you follow the guide with ▶ Guide, you point at each element it can’t find and the guide learns it.',
    copyPrompt: 'Copy instructions for the AI',
    copied: 'Instructions copied. Paste them into the AI and add the task at the end.',
    couldNotCopy: 'Could not copy the instructions.',
    content: 'The AI’s answer',
    contentHint: 'Paste the JSON here or choose a .json file.',
    chooseFile: 'Choose file…',
    cancel: 'Cancel',
    submit: 'Import',
    errJson: 'This isn’t JSON. Paste the AI’s whole answer.',
    errFormat: 'This isn’t a Nolens Guides file (the “format” field is missing or different).',
    errNoSteps: 'The file has no steps.',
    errTooMany: 'The file has too many steps (500 at most).',
    errNoOpen: 'The first action must be “open”, with the address where the task starts.',
    errStep: (n: number, reason: string) => `Step ${n}: ${reason}`,
    reasonAction: 'unknown action.',
    reasonUrl: 'the address isn’t a valid https address.',
    reasonElement: 'the element has no text, label or selector.',
    reasonOption: 'the option to choose is missing.',
    reasonText: 'the note has no text.',
    failed: 'Could not import the guide.',
  },
  {
    'pt-PT': {
      import: 'Importar',
      title: 'Importar um guia',
      hint: 'Peça a uma IA os passos de uma tarefa e importe a resposta. Os passos ainda não têm capturas: na primeira vez que seguir o guia com ▶ Guiar, aponta cada elemento que ele não encontrar e o guia aprende-o.',
      copyPrompt: 'Copiar instruções para a IA',
      copied: 'Instruções copiadas. Cole-as na IA e acrescente a tarefa no fim.',
      couldNotCopy: 'Não foi possível copiar as instruções.',
      content: 'A resposta da IA',
      contentHint: 'Cole aqui o JSON ou escolha um ficheiro .json.',
      chooseFile: 'Escolher ficheiro…',
      cancel: 'Cancelar',
      submit: 'Importar',
      errJson: 'Isto não é JSON. Cole a resposta inteira da IA.',
      errFormat: 'Isto não é um ficheiro do Nolens Guides (o campo «format» falta ou é outro).',
      errNoSteps: 'O ficheiro não tem passos.',
      errTooMany: 'O ficheiro tem passos a mais (500 no máximo).',
      errNoOpen: 'A primeira ação tem de ser «open», com o endereço onde a tarefa começa.',
      errStep: (n, reason) => `Passo ${n}: ${reason}`,
      reasonAction: 'ação desconhecida.',
      reasonUrl: 'o endereço não é um endereço https válido.',
      reasonElement: 'o elemento não tem texto, rótulo nem seletor.',
      reasonOption: 'falta a opção a escolher.',
      reasonText: 'a nota não tem texto.',
      failed: 'Não foi possível importar o guia.',
    },
  },
);
